var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymptomWeakErection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
    fill: "#FFCC80",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 55C91 72.6733 76.6733 87 59 87C41.3267 87 27 72.6733 27 55C27 37.3267 41.3267 23 59 23C76.6733 23 91 37.3267 91 55Z",
    fill: "#FFCC80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0454 28.1802C32.5506 26.0632 34.8553 24.9117 36.8338 25.8187C36.8466 25.8246 36.8595 25.8305 36.8725 25.8363C43.7492 28.9923 49.67 32.7836 54.4701 37.1049C60.2414 42.3005 64.4094 48.3058 66.8584 54.9544C67.5801 56.9137 70.0257 55.8893 71.0032 59.2857C71.2004 60.9138 71.3005 62.9755 71.0249 64.9893C70.366 69.806 68.1303 70.5076 67.0559 70.8452C66.9948 70.8643 66.9329 70.8829 66.8722 70.9003C64.8691 71.4768 62.8588 71.1658 60.7267 69.9492C57.3087 67.9989 55.1189 64.617 54.6728 63.3517C53.8646 58.7764 52.8196 55.4293 42.72 47.8371C41.497 46.9176 36.5166 43.252 31.9983 41.0388C30.6032 40.3555 29.8324 38.826 30.1199 37.2992C30.695 34.2451 31.325 31.2005 32.0454 28.1802Z",
    fill: "#A3541A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(27 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomWeakErection);
export default __webpack_public_path__ + "static/media/symptom-Weak-Erection.462329a8d9085556019929005b488ac1.svg";
export { ForwardRef as ReactComponent };